import CompanySingleList from './CompanySingleList';

export default CompanySingleList;

